import PropTypes from 'prop-types';

export const MaxPaxProps = PropTypes.shape({
    maxPassengers: PropTypes.number.isRequired,
    maxChildrenPerAdult: PropTypes.number.isRequired,
    maxInfantsPerAdult: PropTypes.number.isRequired,
});

export const MaxPaxPropsDefaults = {
    maxPassengers: 9,
    maxChildrenPerAdult: 2,
    maxInfantsPerAdult: 1,
};

export const TrainMaxPaxProps = PropTypes.shape({
    maxPassengers: PropTypes.number.isRequired,
    maxChildrenPerYouth: PropTypes.number.isRequired, // 2
    maxChildrenPerAdult: PropTypes.number.isRequired, // 2
    maxChildrenPerSenior: PropTypes.number.isRequired, // 2
    maxInfantsPerAdult: PropTypes.number,
});

export const TrainMaxPaxAgesProps = PropTypes.shape({
    maxYouthAges: PropTypes.number.isRequired,
    maxChildrenAges: PropTypes.number.isRequired,
});

export const TrainMinPaxAgesProps = PropTypes.shape({
    minYouthAges: PropTypes.number.isRequired,
    minChildrenAges: PropTypes.number.isRequired,
});

export const TrainPaxErrorsProps = PropTypes.shape({
    paxSelectorLevelError: PropTypes.string,
    paxAgeFieldLevelError: PropTypes.string,
});

export const TrainMaxPaxPropsDefaults = {
    maxPassengers: 9,
    maxChildrenPerYouth: 2,
    maxChildrenPerAdult: 2,
    maxChildrenPerSenior: 2,
    maxInfantsPerAdult: 1,
};

export const TrainMaxPaxAgesPropsDefaults = {
    maxYouthAges: 29,
    maxChildrenAges: 11,
};

export const TrainMinPaxAgesPropsDefaults = {
    minYouthAges: 12,
    minChildrenAges: 0,
};

export const TrainPaxErrorsPropsDefaults = {
    paxSelectorLevelError: undefined,
    paxAgeFieldLevelError: undefined,
};
